window.CompareCompetitors = phrase => {
	return {
		val: phrase,
	};
};
